var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "big"
  }, [_c("keep-alive", [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()], 1), !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e(), _c("el-row", [_c("div", {
    staticClass: "card"
  }, [_vm._v(" " + _vm._s(_vm.titleName) + " ")])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };